import React, { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { AuthContext } from '../../context/AuthContext';
import StandardLayout from '../../components/layout/StandardLayout';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshSubscriptionStatus } = useContext(AuthContext);
  const returnPath = searchParams.get('return_to') || '/home';

  useEffect(() => {
    const initializeSuccess = async () => {
      try {
        // Refresh the subscription status in AuthContext
        await refreshSubscriptionStatus();
      } catch (error) {
        console.error('Error updating subscription status:', error);
      }
    };

    initializeSuccess();

    // Google Ads Conversion Tracking für erfolgreiche Zahlungen
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-16899827592/purchase_complete',
        'value': 19.99,
        'currency': 'EUR',
        'transaction_id': new Date().getTime().toString(),
        'event_callback': function() {
          console.log('Purchase conversion tracked successfully');
        }
      });
    }

    // Google Analytics E-Commerce Tracking
    if (window.gtag) {
      window.gtag('event', 'purchase', {
        'transaction_id': new Date().getTime().toString(),
        'value': 19.99,
        'currency': 'EUR',
        'items': [
          {
            'item_id': 'SKS_PREMIUM',
            'item_name': 'SKS Premium Zugang',
            'price': 19.99
          }
        ]
      });
    }
  }, [navigate, refreshSubscriptionStatus, returnPath]);

  return (
    <StandardLayout>
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="card bg-base-100 shadow-xl max-w-md w-full">
          <div className="card-body items-center text-center space-y-6">
            {/* Success Icon */}
            <div className="rounded-full bg-success/10 p-4">
              <CheckCircleIcon className="w-12 h-12 text-success" />
            </div>

            {/* Success Message */}
            <div className="space-y-3">
              <h1 className="text-2xl font-bold">Zahlung erfolgreich!</h1>
              <p className="text-base-content/70">
                Vielen Dank für dein Vertrauen. Du hast nun vollen Zugriff auf alle Funktionen von Mein-SKS.
                Eine E-Mail mit den Zahlungsdetails wurde gerade an Deine Adresse gesendet.
              </p>
            </div>

            {/* Manual Return Button */}
            <button 
              onClick={() => navigate(returnPath)}
              className="btn btn-primary w-full"
            >
              Starte jetzt mit der vollen Version von Mein-SKS
            </button>
          </div>
        </div>
      </div>
    </StandardLayout>
  );
};

export default PaymentSuccess; 